import styled from 'styled-components/macro';
import { Header2 } from '../../shared/Headers';
import { spacing01, spacing02, spacing04 } from '../../styling/spacing';

export const BillOfMaterialsFormHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing04};

  ${Header2} {
    margin: 0 0 ${spacing01} ${spacing02};
  }
`;
